



import React from 'react';
import { useRequester } from '../../context/RequesterContext';

const RequesterNav = () => {
  const { openRequestModal } = useRequester();

  const currentPath = typeof window !== 'undefined' ? window.location.pathname : '/';

  const homeUrl = process.env.REACT_APP_HOME_URL || '/';
  const origin = (() => {
    try { return new URL(homeUrl).origin; } catch { return ''; }
  })();

  const navItems = [
    { label: 'Home',               href: homeUrl,                                      target: '_self' },
    { label: 'About MyRiskshield', href: `${origin}/Home/Unauthaboutpage`,             target: '_self' },
    { label: 'Trust Center',       href: process.env.REACT_APP_TRUST_CENTER_URL || `${origin}/trust-center/requester`, target: '_self',
      activeCheck: () => window.location.pathname.startsWith('/requester'),
      onClick: (e) => { if (window.location.pathname.startsWith('/requester')) e.preventDefault(); } },
    { label: 'Company',            href: 'https://itpeoplenetwork.com/',               target: '_blank', rel: 'noreferrer' },
    { label: 'Contact Us',         href: `${origin}/Home/unauthcontactus`,             target: '_self' },
  ];

  const isActive = (href) => {
    if (!href) return false;
    try {
      const current = window.location.href;
      const currentPathname = window.location.pathname;
      // Same origin: compare pathnames
      const hrefUrl = new URL(href, window.location.origin);
      if (hrefUrl.origin === window.location.origin) {
        return currentPathname === hrefUrl.pathname || currentPathname.startsWith(hrefUrl.pathname + '/');
      }
      // Cross-origin (main app links): compare full href
      return current.toLowerCase() === href.toLowerCase() ||
             current.toLowerCase().startsWith(href.toLowerCase());
    } catch {
      return false;
    }
  };

  return (
    <header className="bg-white border-b border-slate-200 sticky top-0 z-40 font-sans" style={{height:'66px'}}>
      <div style={{ width: '100%', paddingRight: '1rem', paddingLeft: '0.4rem' }}>
        <div style={{ display: 'flex', marginRight: '-0.5rem', marginLeft: '-0.5rem', margin: 0 }}>
          {/* Logo - col-md-3 (25%) */}
          <div style={{ flex: '0 0 25%', paddingRight: '0.5rem', paddingLeft: '0.5rem', display: 'flex', alignItems: 'center' }}>
            <a href={process.env.REACT_APP_HOME_URL || '/'} className="flex items-center gap-2" >
              <img
                src={`${process.env.PUBLIC_URL}/myriskshield-logo-loginpage.png`}
                alt="My Risk Shield logo"
                className="w-9 h-9 object-contain"
                style={{width:'168px',height:'63px'}}
              />
              {/* <div className="flex flex-col leading-none">
                <span className="font-bold text-xl text-[#53545a]">Risk Shield</span>
                <span className="font-semibold text-[10px] tracking-widest text-[#ff6600] mt-0.5">DETECT &amp; PROTECT</span>
              </div> */}
            </a>
          </div>

          {/* Nav links - col-md-7 (58.33%) */}
          <div style={{ flex: '0 0 60.20%', paddingRight: '0.5rem', paddingLeft: '0.5rem', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
            <nav style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
              {navItems.map((item, index) => (
                <React.Fragment key={item.href}>
                  {index > 0 && (
                    <span className="text-slate-300 select-none" style={{ fontSize: '1.3rem', fontWeight: '100', color: '#0303038f' ,paddingTop:'16px'}}>|</span>
                  )}
                  <a
                    href={item.href}
                    target={item.target}
                    rel={item.rel}
                    onClick={item.onClick}
                    className={`text-sm font-medium font-sans transition-colors whitespace-nowrap ${
                      (item.activeCheck ? item.activeCheck() : isActive(item.href))
                        ? 'text-[#ff6600]'
                        : 'text-[#5e6060] hover:text-[#ff6600]'
                    }`}
                    style={{
                      padding: '0.75rem 0.75rem',
                      borderBottom: (item.activeCheck ? item.activeCheck() : isActive(item.href)) ? '3px solid #ff6600' : '3px solid transparent',
                      lineHeight: '2.45rem',
                      fontSize: '16px',
                      fontWeight:'400'

                    }}
                  >
                    {item.label}
                  </a>
                </React.Fragment>
              ))}
            </nav>
          </div>

          {/* Login Button - col-md-2 (16.67%) */}
          <div style={{ flex: '0 0 16.67%', paddingRight: '0.5rem', paddingLeft: '0.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <a
              href={`${origin}/Home/LoginPrompt`}
              style={{ padding: '0 15px',height:'35px', display: 'flex', alignItems: 'center', gap: '6px', textDecoration: 'none', background: '#ff6600', color: '#fff', fontSize: '15px', fontWeight: '500' }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#ffffff">
                <path d="M200-246q54-53 125.5-83.5T480-360q83 0 154.5 30.5T760-246v-514H200v514Zm280-194q58 0 99-41t41-99q0-58-41-99t-99-41q-58 0-99 41t-41 99q0 58 41 99t99 41ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm69-80h422q-44-39-99.5-59.5T480-280q-56 0-112.5 20.5T269-200Zm211-320q-25 0-42.5-17.5T420-580q0-25 17.5-42.5T480-640q25 0 42.5 17.5T540-580q0 25-17.5 42.5T480-520Zm0 17Z" />
              </svg>
              LOG IN
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default RequesterNav;
